<template>
  <div class=" p-4 justify-center ">
    <div class="justify-center  mb-4">
      <p><span class="text-lg">Diese Artikelnummer gibt es nicht.</span></p>
      <p>Möchten Sie einen neuen Artikel erstellen?</p>
    </div>
    <div class=" w-full flex flex-col gap-2">

      <div class="flex items-center gap-2">
        <span class="w-[100px]">Artikelnummer:</span>
        <input class="border p-2 rounded flex-grow" readonly="readonly" v-model="value.articleNumber"/>

      </div>
      <div class="flex items-center gap-2">
        <span class="w-[100px]">Einkaufsbereich: </span>
        <select class="border p-2 rounded flex-grow" v-model="teamId">
          <option v-for="section in purchaser" :key="section.id" :value="section.id">
            {{ section.teamIcon }} - {{ section.name }}
          </option>
        </select>
      </div>

      <div class="flex gap-2">
        <button class="bg-trader-gray w-full rounded p-2" @click="closeModal">Abbrechen</button>
        <button class="bg-trader-green w-full rounded p-2" @click="createNewArticleNumber">Erstellen</button>
      </div>
    </div>


  </div>
</template>

<script>

import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import {eventBus} from "@/application/EventBus";
import SignalBus from "@/application/SignalBus";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },

  },

  data() {
    return {
      purchaser: [],
      teamId: null,
    }
  },
  methods: {
    closeModal() {
      eventBus.closeModal();
    },
    async createNewArticleNumber() {
      const productData = {
        teamId: this.teamId,
        productId: this.value.productId,
        pageId: this.value.pageId,
        articleNumber: this.value.articleNumber,
        virtualId: this.value.virtualId,
      }

      const mutation = gql`
        mutation createProduct($product: ArticleInput!) {
          createProduct(product: $product) {
            success
          }
        }
      `;

      try {
        const variables = {
          product: productData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        SignalBus.emit('article-created',);
        SignalBus.emit('reload-page',);


        eventBus.closeModal();
      } catch (error) {
        console.error(error);
      }
    },

    async selectPurchaser() {
      try {
        // Apollo Client Anfrage
        const {data} = await apolloClient.query({
          query: gql`
          query getPurchasers {
            getPurchasers {
              id
              name
              teamPosition
              teamIcon
              color
            }
          }
        `,
        });

        // Stellen Sie sicher, dass die Daten in shoppingSections gespeichert werden
        this.purchaser = data.getPurchasers;
        this.teamId = this.purchaser[0].id;


      } catch (error) {
        console.error("Fehler beim Abrufen der purchaser:", error.message);
      }
    },
  },
  mounted() {
    this.selectPurchaser();

  }

}


</script>

